module.exports = __webpack_public_path__ + "static/images/facebook.2f37d1bf3b000251a1cf97e6d65fbeaf.svg";